import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const historias = [
  {
    nome: 'Dra. Fernanda Leal',
    idade: 43,
    cargo: 'CEO · HealthTech · São Paulo',
    foto: 'https://public.readdy.ai/ai/img_res/7c71775dd3143ce17b2fd620ee985669.jpg',
    antes: 'Síndrome da impostora após promoção a CEO',
    depois: 'Autoridade real. Faturamento 3x em 14 meses.',
    depoimento: 'I had every credential but doubted every decision. O método me deu a chave que nenhum MBA entrega: reprogramação do que me definia internamente. Hoje lidero com clareza, não com medo.',
    resultado: 'Triplicou o faturamento da empresa em 14 meses',
    idioma: 'EN / PT',
  },
  {
    nome: 'Marcia Torres',
    idade: 38,
    cargo: 'VP Marketing · Multinacional · Rio',
    foto: 'https://readdy.ai/api/search-image?query=professional%20successful%20woman%20VP%20executive%2038%20years%20old%20confident%20smile%20minimal%20dark%20background%20luxury%20premium%20corporate%20portrait%20elegant%20feminine%20strong&width=480&height=600&seq=ps-exec-02&orientation=portrait',
    antes: 'Burnout silencioso. Performava para fora, apagava por dentro.',
    depois: 'Energia, presença e resultados que nunca imaginei.',
    depoimento: 'Tried executive coaching, tried therapy. Both helped marginally. Bia Holmes foi diferente porque trabalhou na causa, não no sintoma. Em 8 semanas me reconheci novamente.',
    resultado: 'Promovida a VP global em 6 meses',
    idioma: 'EN / PT',
  },
  {
    nome: 'Ana Clara Ribeiro',
    idade: 46,
    cargo: 'Médica · Palestrante · Brasília',
    foto: 'https://readdy.ai/api/search-image?query=elegant%20sophisticated%20Brazilian%20woman%20doctor%20professional%2046%20years%20old%20minimal%20background%20warm%20tones%20confident%20authoritative%20medical%20professional%20portrait%20high%20quality&width=480&height=600&seq=ps-exec-03&orientation=portrait',
    antes: 'Excelente médica. Péssima em dizer não. Esgotamento total.',
    depois: 'Presença plena. Limites saudáveis. Vida inteira de novo.',
    depoimento: 'Como médica, entendia neurofisiologicamente o que o método faz. Como paciente, precisei vivenciar. Recuperei minha identidade além do jaleco — algo que achei ter perdido para sempre.',
    resultado: 'Criou sua clínica e reduziu a jornada em 40%',
    idioma: 'PT',
  },
];

const stats = [
  { value: '10.347', label: 'Mulheres transformadas', icon: 'ri-group-line' },
  { value: '4.9/5', label: 'Avaliação das alunas', icon: 'ri-star-fill' },
  { value: '89%', label: 'Melhora emocional na 1ª semana', icon: 'ri-emotion-happy-line' },
  { value: '35+', label: 'Média de idade das alunas', icon: 'ri-calendar-line' },
];

const notificacoes = [
  { nome: 'Camila B.', acao: 'fez o diagnóstico de padrões', tempo: '3 min atrás' },
  { nome: 'Renata M.', acao: 'iniciou o exercício Linha do Tempo', tempo: '7 min atrás' },
  { nome: 'Patricia A.', acao: 'completou 21 dias de streak', tempo: '11 min atrás' },
  { nome: 'Luciana F.', acao: 'desbloqueou o protocolo Swish', tempo: '15 min atrás' },
  { nome: 'Daniela C.', acao: 'acessou o plano Transformação', tempo: '18 min atrás' },
];

export default function ProvaSocial() {
  const [notificacaoAtual, setNotificacaoAtual] = useState(0);
  const [mostrarNotif, setMostrarNotif] = useState(true);
  const [activeCard, setActiveCard] = useState<number | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setMostrarNotif(false);
      setTimeout(() => {
        setNotificacaoAtual((prev) => (prev + 1) % notificacoes.length);
        setMostrarNotif(true);
      }, 500);
    }, 5000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <section className="py-28 px-6 bg-gradient-to-b from-charcoal-950 via-charcoal-900 to-charcoal-950 relative overflow-hidden">
      {/* Ornamentos */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
        <div className="absolute top-1/3 left-0 w-96 h-96 bg-gold-500/4 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 right-0 w-80 h-80 bg-gold-400/3 rounded-full blur-3xl"></div>
      </div>

      {/* Notificação flutuante */}
      <div
        className={`fixed bottom-8 left-8 z-50 transition-all duration-500 hidden lg:block ${
          mostrarNotif ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
        }`}
      >
        <div className="bg-charcoal-900/95 border border-gold-500/20 rounded-xl p-4 backdrop-blur-xl max-w-xs">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-gradient-to-br from-gold-500 to-gold-700 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-user-line text-charcoal-900 text-sm"></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-xs font-semibold truncate">{notificacoes[notificacaoAtual].nome}</p>
              <p className="text-white/50 text-xs truncate">{notificacoes[notificacaoAtual].acao}</p>
            </div>
            <div className="w-2 h-2 bg-gold-400 rounded-full animate-pulse flex-shrink-0"></div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <ScrollRevealWrapper animation="fade-up">
          <div className="max-w-3xl mb-20">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-6 bg-gold-500/50"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.25em] uppercase font-['Montserrat']">
                Resultados reais · Mulheres reais
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white leading-[1.05] mb-5">
              Quando a mente para de<br />
              <span className="text-gold-400">sabotar, tudo muda.</span>
            </h2>
            <p className="text-white/55 text-lg font-light leading-relaxed font-['Montserrat']">
              Executivas, empresárias e profissionais de alta renda que decidiram resolver o bloqueio interno — e o que aconteceu depois.
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Stats */}
        <ScrollRevealWrapper animation="fade-up" delay={0.1}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-20">
            {stats.map((s) => (
              <div key={s.label} className="bg-white/4 border border-gold-500/10 rounded-xl p-5 text-center">
                <div className="w-9 h-9 flex items-center justify-center mx-auto mb-3">
                  <i className={`${s.icon} text-xl text-gold-400`}></i>
                </div>
                <div className="font-display text-3xl font-bold text-gold-400 mb-1">{s.value}</div>
                <div className="text-white/40 text-xs font-['Montserrat'] leading-tight">{s.label}</div>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* Cards de histórias */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {historias.map((h, i) => (
            <ScrollRevealWrapper key={i} animation="fade-up" delay={0.1 * (i + 1)}>
              <div
                className={`group relative bg-charcoal-900 border rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                  activeCard === i ? 'border-gold-400/50' : 'border-gold-500/10 hover:border-gold-400/30'
                }`}
                onClick={() => setActiveCard(activeCard === i ? null : i)}
              >
                {/* Foto */}
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={h.foto}
                    alt={h.nome}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900 via-charcoal-900/30 to-transparent"></div>

                  {/* Badge idioma */}
                  <div className="absolute top-4 right-4 px-2.5 py-1 bg-charcoal-950/80 border border-gold-500/20 rounded-full text-gold-400 text-xs font-semibold font-['Montserrat'] backdrop-blur-sm">
                    {h.idioma}
                  </div>
                </div>

                {/* Info */}
                <div className="p-6">
                  <div className="mb-4">
                    <h3 className="font-display text-lg font-bold text-white mb-0.5">{h.nome}</h3>
                    <p className="text-gold-400 text-xs font-['Montserrat']">{h.cargo}</p>
                  </div>

                  {/* Antes/Depois */}
                  <div className="grid grid-cols-2 gap-2 mb-5">
                    <div className="bg-charcoal-950/60 border border-white/5 rounded-lg px-3 py-2">
                      <p className="text-white/40 text-xs font-bold uppercase tracking-wider mb-1 font-['Montserrat']">Antes</p>
                      <p className="text-white/60 text-xs leading-snug font-['Montserrat']">{h.antes}</p>
                    </div>
                    <div className="bg-gold-500/8 border border-gold-500/15 rounded-lg px-3 py-2">
                      <p className="text-gold-400 text-xs font-bold uppercase tracking-wider mb-1 font-['Montserrat']">Depois</p>
                      <p className="text-white/80 text-xs leading-snug font-['Montserrat']">{h.depois}</p>
                    </div>
                  </div>

                  {/* Depoimento */}
                  <blockquote className="border-l-2 border-gold-500/30 pl-4 mb-4">
                    <p className="text-white/55 text-xs italic leading-relaxed font-['Montserrat']">
                      &ldquo;{h.depoimento}&rdquo;
                    </p>
                  </blockquote>

                  {/* Resultado */}
                  <div className="flex items-center gap-2">
                    <i className="ri-trophy-fill text-gold-400 text-sm flex-shrink-0"></i>
                    <p className="text-white/70 text-xs font-semibold font-['Montserrat']">{h.resultado}</p>
                  </div>
                </div>
              </div>
            </ScrollRevealWrapper>
          ))}
        </div>

        {/* CTA final da seção */}
        <ScrollRevealWrapper animation="fade-up" delay={0.4}>
          <div className="text-center">
            <p className="text-white/40 text-sm font-['Montserrat'] mb-6">
              Sua história pode ser a próxima.
            </p>
            <Link
              to="/quiz"
              className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-full font-bold hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] text-sm tracking-wide"
            >
              <i className="ri-brain-line"></i>
              Fazer Meu Diagnóstico Agora
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
